import { render, staticRenderFns } from "./Setting-company.vue?vue&type=template&id=398c069f"
import script from "./Setting-company.vue?vue&type=script&lang=js"
export * from "./Setting-company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports